import { render, staticRenderFns } from "./cp_tzz_sq_bf.vue?vue&type=template&id=306e24b2&scoped=true"
import script from "./cp_tzz_sq_bf.vue?vue&type=script&lang=js"
export * from "./cp_tzz_sq_bf.vue?vue&type=script&lang=js"
import style0 from "./cp_tzz_sq_bf.vue?vue&type=style&index=0&id=306e24b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306e24b2",
  null
  
)

export default component.exports